import { render, staticRenderFns } from "./ChangeWarrantyProductV2.vue?vue&type=template&id=477f201a&scoped=true"
import script from "./ChangeWarrantyProductV2.vue?vue&type=script&lang=js"
export * from "./ChangeWarrantyProductV2.vue?vue&type=script&lang=js"
import style0 from "./ChangeWarrantyProductV2.vue?vue&type=style&index=0&id=477f201a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f201a",
  null
  
)

export default component.exports